import '../styles/App.css';
import { PhaseManager } from './components/phase_manager';

export function App() {
	return (
		<div className="App">
			<PhaseManager />
		</div>
	);
}